"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _save_styles = _interopRequireDefault(require("./save_styles"));

var _save_definition = _interopRequireDefault(require("./save_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : SAVE BUTTON ~~~~~~~~~~ ========== */


var SaveButton = (0, _reactJss.default)(_save_styles.default)(function (props) {
  return _react.default.createElement(_index.Button, {
    type: 'action',
    icon: !!props.removeIcon ? null : "save",
    action: props.handleSave,
    variant: props.variant ? props.variant : "action",
    klass: "".concat(props.classes.save),
    name: "save-changes",
    text: !!props.buttonText ? props.buttonText : "Save",
    operation: !!props.operation ? props.operation : "save",
    processing: props.savingData,
    disabled: !!props.disabled
  });
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(SaveButton, _save_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = SaveButton;
exports.default = _default;